var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H4C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H13C14.1046 18 15 17.1046 15 16V15C15 14.4477 15.4477 14 16 14C16.5523 14 17 14.4477 17 15V16C17 18.2091 15.2091 20 13 20H4C1.79086 20 0 18.2091 0 16V4C0 1.79086 1.79086 0 4 0H13C15.2091 0 17 1.79086 17 4V5C17 5.55229 16.5523 6 16 6C15.4477 6 15 5.55229 15 5V4C15 2.89543 14.1046 2 13 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9104 3.24138C20.5605 3.57466 20.547 4.12851 20.8803 4.47845L25.1865 9H8C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H25.1865L20.8803 15.5216C20.547 15.8715 20.5605 16.4253 20.9104 16.7586C21.2604 17.0919 21.8142 17.0784 22.1475 16.7284L27.5977 11.0057C28.1341 10.4425 28.1341 9.55747 27.5977 8.99425L22.1475 3.27155C21.8142 2.92161 21.2604 2.90811 20.9104 3.24138Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.edb31a9985ccfab3e6631770757ca83c.svg";
export { ForwardRef as ReactComponent };